import { postRequest } from "../requests";

export interface PatientMatchParams {
    StateKey: string;
    PatientMappings: any;
}

export async function confirmPatientMatch(params: PatientMatchParams) {
    return postRequest('api/cfhrprovideraccounts/account', params);
}
